import { appConfig } from '@/config/app.ts'
import { MarketplaceProductTarget } from '@/modules/marketplace/products/types/MarketplaceProduct.ts'

export interface MarketplaceProductState {
  isCreateModalOpen: boolean
  editTarget: MarketplaceProductTarget | null
  sponsoredTarget: MarketplaceProductTarget | null
  filters: string
}

export const initialState: MarketplaceProductState = {
  isCreateModalOpen: false,
  editTarget: null,
  sponsoredTarget: null,
  filters: `?limit=${appConfig.pagination.defaultValue}`
}
